import { FileWithPath } from '@mantine/dropzone';
import { useEffect, useState } from 'react';
import { getFileExtension, mainTypeGroups } from '@/utils/fileUtils';
import JSZip from 'jszip';
import { useUserQuery } from '@/shared/hooks/useUserQuery';

const extraPaidFiles: Record<string, number> = {
  max: 5,
  // stp: 1,
  // step: 1,
  // igs: 1,
  // iges: 1,
};

export const useUploadCredits = (files: FileWithPath[]) => {
  const [credits, setCredits] = useState(0);
  const { data: user } = useUserQuery();
  const uploadPrice = user?.plan?.details?.import_cost ?? 0;
  const newPlan = uploadPrice !== 0;

  useEffect(() => {
    const calculateCredits = async () => {
      let newCredits = 0;

      for (const file of files) {
        if (file.type === 'application/zip') {
          const zip = new JSZip();
          const loadedZip = await zip.loadAsync(file, { createFolders: true });

          const names = Object.values(loadedZip.files)
            .map((file) => file.name)
            .filter((name) => !name.startsWith('__MACOSX'));

          newCredits += names.reduce((acc, next) => {
            if (newPlan) {
              return acc + (isModel(next) ? uploadPrice : 0);
            }
            return (extraPaidFiles[getFileExtension({ name: next }).toLocaleLowerCase()] ?? 0) + acc;
          }, 0);
          continue;
        }

        newCredits += newPlan
          ? isModel(file.name)
            ? uploadPrice
            : 0
          : (extraPaidFiles[getFileExtension(file).toLocaleLowerCase()] ?? 0);
      }
      setCredits(newCredits);
    };

    calculateCredits();
  }, [files]);

  return { credits };
};

const isModel = (fileName: string) => {
  const modelTypes = mainTypeGroups.flat();
  return modelTypes.includes(getFileExtension({ name: fileName }));
};
